import {
    AutocompleteInput,
    DateInput,
    Edit,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, ClipboardCheck, Settings } from 'lucide-react';
import { required } from 'ra-core';

export const WorkOrderEdit = () => (
    <Edit title="Edit Work Order">
        <SimpleForm className="max-w-5xl mx-auto space-y-6">
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-slate-50/50">
                    <div className="flex items-center gap-2">
                        <Settings className="w-5 h-5 text-slate-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Work Order Details</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <TextInput source="reference" label="WO Reference" validate={required()} className="w-full font-mono" />
                        <ReferenceInput source="project_id" reference="projects">
                            <AutocompleteInput label="Project" validate={required()} className="w-full" />
                        </ReferenceInput>
                        <SelectInput
                            source="status"
                            label="Status"
                            validate={required()}
                            choices={[
                                { id: 'open', name: 'Open' },
                                { id: 'in_progress', name: 'In Progress' },
                                { id: 'completed', name: 'Completed' },
                                { id: 'cancelled', name: 'Cancelled' },
                            ]}
                            className="w-full"
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
                        <SelectInput
                            source="priority"
                            label="Priority"
                            validate={required()}
                            choices={[
                                { id: 'low', name: 'Low' },
                                { id: 'medium', name: 'Medium' },
                                { id: 'high', name: 'High' },
                                { id: 'urgent', name: 'Urgent' },
                            ]}
                            className="w-full"
                        />
                        <ReferenceInput source="assigned_to" reference="sales">
                            <AutocompleteInput label="Assign To" className="w-full" optionText={(record: any) => record ? `${record.first_name} ${record.last_name}` : ''} />
                        </ReferenceInput>
                        <ReferenceInput source="bom_id" reference="boms">
                            <AutocompleteInput label="Bill of Materials" className="w-full" />
                        </ReferenceInput>
                    </div>
                </CardContent>
            </Card>

            <Card className="w-full shadow-sm border-t-4 border-t-slate-900">
                <CardHeader className="pb-3 border-b">
                    <div className="flex items-center gap-2">
                        <Calendar className="w-5 h-5 text-slate-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Schedule & Specs</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <DateInput source="start_date" label="Start Date" validate={required()} />
                        <DateInput source="target_completion" label="Target Completion" />
                        <DateInput source="actual_completion" label="Actual Completion" />
                    </div>
                    <div className="mt-4">
                        <TextInput source="production_specs" label="Production Specifications" multiline rows={4} className="w-full" />
                    </div>
                </CardContent>
            </Card>

            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-slate-50/50">
                    <div className="flex items-center gap-2">
                        <ClipboardCheck className="w-5 h-5 text-slate-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Quality Assurance</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <SelectInput
                            source="qa_status"
                            label="QA Status"
                            choices={[
                                { id: 'pending', name: 'Pending' },
                                { id: 'passed', name: 'Passed' },
                                { id: 'failed', name: 'Failed' },
                            ]}
                            className="w-full"
                        />
                    </div>
                    <div className="mt-4">
                        <TextInput source="notes" label="QA Notes & Remarks" multiline rows={3} className="w-full" />
                    </div>
                </CardContent>
            </Card>
        </SimpleForm>
    </Edit>
);
